import React, { useState, useEffect } from 'react';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import FormInput from '../../components/ui/FormInput';
import { useUserProfile } from '../../contexts/UserContext';
import {
  ROLES, ROLE_LABELS, ROLE_COLORS,
  subscribeUsers, subscribeTeams,
  createUserInvite, updateUserRole, assignGestor, assignTeam,
  deactivateUser, reactivateUser, deleteUser,
  createTeam, updateTeam, deleteTeam,
} from '../../services/userService';

const AVATAR_COLORS = ['#3B82F6', '#8B5CF6', '#14B8A6', '#F43F5E', '#F97316', '#EC4899', '#6366F1'];
function getColor(str) {
  let h = 0;
  for (let i = 0; i < (str || '').length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}
function getIniciais(name) {
  return (name || 'U').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
}

// ======== MODAL NOVO USUÁRIO ========
function NovoUsuarioModal({ open, onClose, profile, teams, gestores }) {
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [role, setRole] = useState(ROLES.USUARIO);
  const [teamId, setTeamId] = useState('');
  const [gestorId, setGestorId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [inviteLink, setInviteLink] = useState('');
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const rolesDisponiveis = profile.role === ROLES.MASTER
    ? [ROLES.GESTOR, ROLES.USUARIO]
    : [ROLES.USUARIO];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    setInviteLink('');
    try {
      await createUserInvite(profile, { email, displayName: nome, role, teamId: teamId || null, gestorId: gestorId || null });
      const link = `${window.location.origin}/cadastro?invite=${encodeURIComponent(email.toLowerCase().trim())}`;
      setInviteLink(link);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch {
      // Fallback
      const ta = document.createElement('textarea');
      ta.value = inviteLink;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }
  };

  const handleClose = () => {
    setInviteLink('');
    setCopied(false);
    setEmail(''); setNome(''); setRole(ROLES.USUARIO); setTeamId(''); setGestorId('');
    onClose();
  };

  const selectStyle = {
    width: '100%', padding: '10px 12px', border: '1.5px solid var(--border)',
    borderRadius: 'var(--radius-xs)', fontFamily: 'var(--font)', fontSize: '0.82rem',
    color: 'var(--text)', background: 'var(--white)', outline: 'none',
  };

  return (
    <div onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(11,29,53,0.5)', backdropFilter: 'blur(4px)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--white)', borderRadius: 20, width: '100%', maxWidth: 480, padding: 32, boxShadow: '0 40px 80px rgba(0,0,0,0.15)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <span style={{ fontSize: '1.1rem', fontWeight: 700 }}>{inviteLink ? '✅ Convite Criado' : 'Novo Usuário'}</span>
          <button onClick={handleClose} style={{ width: 32, height: 32, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--white)', cursor: 'pointer', fontSize: '0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>

        {error && <div style={{ padding: '8px 12px', borderRadius: 8, background: 'rgba(239,68,68,0.08)', color: '#DC2626', fontSize: '0.78rem', marginBottom: 12 }}>⚠️ {error}</div>}

        {/* Invite Link Success */}
        {inviteLink ? (
          <div>
            <div style={{
              padding: '16px 18px', borderRadius: 12, marginBottom: 16,
              background: 'rgba(0,214,143,0.06)', border: '1px solid rgba(0,214,143,0.15)',
            }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#059669', marginBottom: 8 }}>
                Envie o link abaixo para <strong>{email}</strong>
              </div>
              <div style={{
                padding: '10px 14px', background: 'var(--white)', borderRadius: 8,
                border: '1px solid var(--border)', fontSize: '0.72rem', fontFamily: 'monospace',
                wordBreak: 'break-all', color: 'var(--text-muted)', marginBottom: 10,
              }}>
                {inviteLink}
              </div>
              <button onClick={handleCopyLink} style={{
                width: '100%', padding: 10, border: 'none', borderRadius: 8,
                fontFamily: 'var(--font)', fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer',
                background: copied ? '#059669' : 'var(--accent)', color: copied ? '#fff' : 'var(--primary)',
                transition: 'all 0.2s',
              }}>
                {copied ? '✅ Link copiado!' : '📋 Copiar Link de Convite'}
              </button>
            </div>
            <p style={{ fontSize: '0.72rem', color: 'var(--text-muted)', textAlign: 'center' }}>
              O usuário deve acessar o link acima para criar sua senha e ativar a conta.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <Button variant="ghost" onClick={handleClose}>Fechar</Button>
            </div>
          </div>
        ) : (

        <form onSubmit={handleSubmit}>
          <FormInput label="E-mail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="usuario@email.com" />
          <FormInput label="Nome" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome do usuário" />

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, marginBottom: 6, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Papel</label>
            <select value={role} onChange={(e) => setRole(e.target.value)} style={selectStyle}>
              {rolesDisponiveis.map((r) => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
            </select>
          </div>

          {profile.role === ROLES.MASTER && role === ROLES.USUARIO && gestores.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, marginBottom: 6, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Vincular a Gestor (opcional)</label>
              <select value={gestorId} onChange={(e) => setGestorId(e.target.value)} style={selectStyle}>
                <option value="">Sem gestor</option>
                {gestores.map((g) => <option key={g.id} value={g.uid || g.id}>{g.displayName || g.email}</option>)}
              </select>
            </div>
          )}

          {teams.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, marginBottom: 6, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Equipe (opcional)</label>
              <select value={teamId} onChange={(e) => setTeamId(e.target.value)} style={selectStyle}>
                <option value="">Sem equipe</option>
                {teams.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
          )}

          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
            <Button variant="ghost" type="button" onClick={handleClose}>Cancelar</Button>
            <Button variant="accent" type="submit" disabled={loading}>
              {loading ? 'Criando...' : '➕ Criar Usuário'}
            </Button>
          </div>
        </form>
        )}
      </div>
    </div>
  );
}

// ======== MODAL NOVA EQUIPE ========
function NovaEquipeModal({ open, onClose, profile, gestores }) {
  const [nome, setNome] = useState('');
  const [gestorId, setGestorId] = useState('');
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nome) return;
    setLoading(true);
    try {
      await createTeam(profile, { nome, gestorId: gestorId || null });
      onClose();
      setNome(''); setGestorId('');
    } catch (err) {
      alert(err.message);
    }
    setLoading(false);
  };

  const selectStyle = {
    width: '100%', padding: '10px 12px', border: '1.5px solid var(--border)',
    borderRadius: 'var(--radius-xs)', fontFamily: 'var(--font)', fontSize: '0.82rem',
    color: 'var(--text)', background: 'var(--white)', outline: 'none',
  };

  return (
    <div onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(11,29,53,0.5)', backdropFilter: 'blur(4px)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--white)', borderRadius: 20, width: '100%', maxWidth: 420, padding: 32, boxShadow: '0 40px 80px rgba(0,0,0,0.15)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <span style={{ fontSize: '1.1rem', fontWeight: 700 }}>Nova Equipe</span>
          <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--white)', cursor: 'pointer', fontSize: '0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <FormInput label="Nome da Equipe" required value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Ex: Equipe Comercial SP" />
          {profile.role === ROLES.MASTER && gestores.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, marginBottom: 6, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Gestor Responsável</label>
              <select value={gestorId} onChange={(e) => setGestorId(e.target.value)} style={selectStyle}>
                <option value="">Eu mesmo</option>
                {gestores.map((g) => <option key={g.id} value={g.uid || g.id}>{g.displayName || g.email}</option>)}
              </select>
            </div>
          )}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
            <Button variant="ghost" type="button" onClick={onClose}>Cancelar</Button>
            <Button variant="accent" type="submit" disabled={loading}>
              {loading ? 'Criando...' : '➕ Criar Equipe'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ======== PAGE ========
export default function UsuariosPage() {
  const { profile, isMaster, canManageUsers } = useUserProfile();
  const [tab, setTab] = useState('usuarios');
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [showNovoUsuario, setShowNovoUsuario] = useState(false);
  const [showNovaEquipe, setShowNovaEquipe] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    if (!profile || !canManageUsers) return;
    const unsub1 = subscribeUsers(profile, setUsers);
    const unsub2 = subscribeTeams(profile, setTeams);
    return () => { unsub1(); unsub2(); };
  }, [profile, canManageUsers]);

  if (!canManageUsers) {
    return (
      <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>
        <span style={{ fontSize: '2.5rem' }}>🔒</span>
        <p style={{ fontSize: '1rem', fontWeight: 600, marginTop: 12 }}>Acesso Restrito</p>
        <p style={{ fontSize: '0.85rem' }}>Apenas Masters e Gestores podem gerenciar usuários.</p>
      </div>
    );
  }

  const gestores = users.filter((u) => u.role === ROLES.GESTOR);
  const filteredUsers = users.filter((u) => {
    if (u.uid === profile.uid) return false; // Não mostra a si mesmo
    const str = `${u.displayName || ''} ${u.email || ''}`.toLowerCase();
    return str.includes(busca.toLowerCase());
  });

  const getTeamName = (teamId) => teams.find((t) => t.id === teamId)?.nome || '—';
  const getGestorName = (gestorId) => {
    if (!gestorId) return '—';
    if (gestorId === profile.uid) return 'Você';
    const g = users.find((u) => (u.uid || u.id) === gestorId);
    return g?.displayName || g?.email || '—';
  };

  const handleRoleChange = async (userId, newRole) => {
    try { await updateUserRole(profile, userId, newRole); }
    catch (err) { alert(err.message); }
  };

  const handleTeamChange = async (userId, teamId) => {
    try { await assignTeam(userId, teamId || null); }
    catch (err) { alert(err.message); }
  };

  const handleToggleStatus = async (user) => {
    if (user.status === 'active') await deactivateUser(user.id);
    else await reactivateUser(user.id);
  };

  const handleDeleteUser = async (user) => {
    if (!window.confirm(`Excluir ${user.displayName || user.email}?`)) return;
    await deleteUser(user.id);
  };

  const handleDeleteTeam = async (team) => {
    if (!window.confirm(`Excluir equipe "${team.nome}"? Membros serão desvinculados.`)) return;
    await deleteTeam(team.id);
  };

  const tdStyle = { padding: '12px 16px', fontSize: '0.82rem', borderBottom: '1px solid var(--border)' };
  const selectStyle = {
    padding: '4px 8px', border: '1px solid var(--border)', borderRadius: 6,
    fontFamily: 'var(--font)', fontSize: '0.75rem', background: 'var(--white)', cursor: 'pointer',
  };

  return (
    <>
      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 24 }}>
        {[
          { label: 'Total Usuários', value: users.length, cor: 'var(--accent)' },
          { label: 'Gestores', value: gestores.length, cor: '#3B82F6' },
          { label: 'Equipes', value: teams.length, cor: '#8B5CF6' },
          { label: 'Pendentes', value: users.filter((u) => u.status === 'pending').length, cor: '#F5A623' },
        ].map((s) => (
          <div key={s.label} style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '16px 18px' }}>
            <div style={{ fontSize: '1.4rem', fontWeight: 700, color: s.cor }}>{s.value}</div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: 'var(--white)', borderRadius: 12, padding: 4, border: '1px solid var(--border)', maxWidth: 320 }}>
        {[
          { key: 'usuarios', label: '👥 Usuários' },
          { key: 'equipes', label: '🏢 Equipes' },
        ].map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            flex: 1, padding: '8px 14px', border: 'none', borderRadius: 10,
            fontFamily: 'var(--font)', fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer',
            background: tab === t.key ? 'var(--accent)' : 'transparent',
            color: tab === t.key ? 'var(--primary)' : 'var(--text-muted)',
          }}>{t.label}</button>
        ))}
      </div>

      {/* ======== USUARIOS ======== */}
      {tab === 'usuarios' && (
        <Card style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--border)' }}>
            <input type="text" placeholder="Buscar por nome ou e-mail..." value={busca} onChange={(e) => setBusca(e.target.value)}
              style={{ padding: '8px 14px', border: '1.5px solid var(--border)', borderRadius: 'var(--radius-xs)', fontFamily: 'var(--font)', fontSize: '0.82rem', width: 280, outline: 'none' }} />
            <Button variant="accent" onClick={() => setShowNovoUsuario(true)}>➕ Novo Usuário</Button>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Usuário', 'Papel', 'Equipe', 'Gestor', 'Status', ''].map((h) => (
                  <th key={h} style={{
                    textAlign: 'left', fontSize: '0.68rem', fontWeight: 600, color: 'var(--text-muted)',
                    textTransform: 'uppercase', letterSpacing: '0.05em', padding: '10px 16px',
                    background: 'var(--surface)', borderBottom: '1px solid var(--border)',
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 && (
                <tr><td colSpan={6} style={{ ...tdStyle, textAlign: 'center', color: 'var(--text-muted)', padding: 40 }}>
                  {busca ? 'Nenhum usuário encontrado.' : 'Nenhum usuário cadastrado ainda.'}
                </td></tr>
              )}
              {filteredUsers.map((u) => {
                const cor = getColor(u.displayName || u.email);
                const iniciais = getIniciais(u.displayName || u.email);
                const roleStyle = ROLE_COLORS[u.role] || ROLE_COLORS.usuario;
                const isPending = u.status === 'pending';
                const isInactive = u.status === 'inactive';

                return (
                  <tr key={u.id} style={{ opacity: isInactive ? 0.5 : 1 }}>
                    <td style={tdStyle}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, color: '#fff', background: cor, flexShrink: 0 }}>{iniciais}</div>
                        <div>
                          <div style={{ fontWeight: 600 }}>{u.displayName || '—'}</div>
                          <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>{u.email}</div>
                        </div>
                      </div>
                    </td>
                    <td style={tdStyle}>
                      {isMaster ? (
                        <select value={u.role} onChange={(e) => handleRoleChange(u.id, e.target.value)} style={selectStyle}>
                          <option value={ROLES.GESTOR}>{ROLE_LABELS.gestor}</option>
                          <option value={ROLES.USUARIO}>{ROLE_LABELS.usuario}</option>
                        </select>
                      ) : (
                        <span style={{ fontSize: '0.72rem', fontWeight: 600, padding: '3px 10px', borderRadius: 100, background: roleStyle.bg, color: roleStyle.color }}>
                          {ROLE_LABELS[u.role]}
                        </span>
                      )}
                    </td>
                    <td style={tdStyle}>
                      <select value={u.teamId || ''} onChange={(e) => handleTeamChange(u.id, e.target.value)} style={selectStyle}>
                        <option value="">Sem equipe</option>
                        {teams.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
                      </select>
                    </td>
                    <td style={{ ...tdStyle, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                      {getGestorName(u.gestorId)}
                    </td>
                    <td style={tdStyle}>
                      <span style={{
                        fontSize: '0.68rem', fontWeight: 600, padding: '3px 10px', borderRadius: 100,
                        background: isPending ? 'rgba(245,166,35,0.1)' : isInactive ? 'rgba(244,63,94,0.1)' : 'rgba(0,214,143,0.1)',
                        color: isPending ? '#D97706' : isInactive ? '#F43F5E' : '#059669',
                      }}>
                        {isPending ? 'Pendente' : isInactive ? 'Inativo' : 'Ativo'}
                      </span>
                    </td>
                    <td style={tdStyle}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button onClick={() => handleToggleStatus(u)} title={u.status === 'active' ? 'Desativar' : 'Reativar'}
                          style={{ width: 28, height: 28, borderRadius: 6, border: '1px solid var(--border)', background: 'var(--white)', cursor: 'pointer', fontSize: '0.72rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {u.status === 'active' ? '⏸️' : '▶️'}
                        </button>
                        <button onClick={() => handleDeleteUser(u)} title="Excluir"
                          style={{ width: 28, height: 28, borderRadius: 6, border: '1px solid var(--border)', background: 'var(--white)', cursor: 'pointer', fontSize: '0.72rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      )}

      {/* ======== EQUIPES ======== */}
      {tab === 'equipes' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
            <Button variant="accent" onClick={() => setShowNovaEquipe(true)}>➕ Nova Equipe</Button>
          </div>

          {teams.length === 0 ? (
            <Card style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
              <span style={{ fontSize: '2rem' }}>🏢</span>
              <p style={{ fontSize: '0.88rem', fontWeight: 600, marginTop: 8 }}>Nenhuma equipe criada</p>
              <p style={{ fontSize: '0.78rem' }}>Crie equipes para organizar seus usuários</p>
            </Card>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
              {teams.map((team) => {
                const membros = users.filter((u) => u.teamId === team.id);
                return (
                  <Card key={team.id} style={{ padding: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                      <div>
                        <div style={{ fontSize: '0.92rem', fontWeight: 700 }}>{team.nome}</div>
                        <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 2 }}>
                          Gestor: {getGestorName(team.gestorId)}
                        </div>
                      </div>
                      <button onClick={() => handleDeleteTeam(team)} title="Excluir equipe"
                        style={{ width: 28, height: 28, borderRadius: 6, border: '1px solid var(--border)', background: 'var(--white)', cursor: 'pointer', fontSize: '0.72rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        🗑️
                      </button>
                    </div>

                    <div style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
                      Membros ({membros.length})
                    </div>

                    {membros.length === 0 ? (
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>Sem membros</div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {membros.map((m) => (
                          <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{
                              width: 24, height: 24, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center',
                              fontSize: '0.55rem', fontWeight: 700, color: '#fff', background: getColor(m.displayName || m.email), flexShrink: 0,
                            }}>{getIniciais(m.displayName || m.email)}</div>
                            <div style={{ flex: 1 }}>
                              <span style={{ fontSize: '0.75rem', fontWeight: 600 }}>{m.displayName || m.email}</span>
                            </div>
                            <span style={{
                              fontSize: '0.6rem', fontWeight: 600, padding: '2px 6px', borderRadius: 100,
                              background: ROLE_COLORS[m.role]?.bg, color: ROLE_COLORS[m.role]?.color,
                            }}>{ROLE_LABELS[m.role]}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </Card>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Modais */}
      <NovoUsuarioModal open={showNovoUsuario} onClose={() => setShowNovoUsuario(false)} profile={profile} teams={teams} gestores={gestores} />
      <NovaEquipeModal open={showNovaEquipe} onClose={() => setShowNovaEquipe(false)} profile={profile} gestores={gestores} />
    </>
  );
}